<div class="rule__section-container">
  <div class="flex items-center gap-3 mb-4">
    <h3 class="nomargin flex-1 mb-3" id="listing-markups">Listing markups</h3>
    <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
  </div>

  <p class="text__small">
    Set the percentage that will be added to your nightly rate, when you make future price updates from the
    {{ 'CORE.PRODUCT_NAME' | transloco }} calendar. This is important to make sure that you receive the same amount
    across your channels, net of platform fees.
  </p>

  <div class="mr-4">
    <div class="rules__rule-header !p-0 hidden md:flex">
      <div class="flex-1">Listing</div>
      <div class="basis-[120px]">Markup rate</div>
    </div>

    <ng-container *ngFor="let listing of property.listings">
      <div
        *ngIf="listing.platform_key !== 'gvr' && listing.platform_key !== 'manual'"
        class="text__small flex flex-col md:flex-row md:items-center gap-2 mb-4">
        <div class="flex-1 flex items-center gap-3">
          <sbnb-mini-listing-img [imgSrc]="listing.picture" imgWidth="26px" imgHeight="20px"></sbnb-mini-listing-img>
          <strong>{{ listing.name }}</strong>
          <sbnb-icon-platform [platform]="listing.platform_key"></sbnb-icon-platform>
        </div>
        <div *ngIf="listing.location" class="hidden md:flex">
          {{ listing.location }}
        </div>
        <div class="md:basis-[120px]">
          <mat-form-field class="input__mini nomargin nopadding max-w-[120px]">
            <input
              class="nopadding nomargin"
              matInput
              type="tel"
              maxlength="7"
              [attr.placeholder]="platformMarkups | findMarkupByChannel: listing.platform_key"
              [value]="listing.listing_id | listingMarkup: markups"
              (change)="listingMarkupChanged(listing, $event.target.value)" />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</div>
